export const TrashIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="path1"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 17.6875 7.3333 L 16.983101 17.4517 C 16.953899 17.8722 16.770399 18.265699 16.4697 18.552999 C 16.1689 18.8403 15.7731 19 15.362101 19 L 8.6379 19 C 8.2269 19 7.8311 18.8403 7.5303 18.552999 C 7.2296 18.265699 7.0461 17.8722 7.0169 17.4517 L 6.3125 7.3333 M 10.375 10.6667 L 10.375 15.6667 M 13.625 10.6667 L 13.625 15.6667 M 14.4375 7.3333 L 14.4375 4.8333 C 14.4375 4.612301 14.3519 4.4004 14.199499 4.244099 C 14.047199 4.087799 13.8405 4 13.625 4 L 10.375 4 C 10.1595 4 9.9528 4.087799 9.8005 4.244099 C 9.6481 4.4004 9.5625 4.612301 9.5625 4.8333 L 9.5625 7.3333 M 5.5 7.3333 L 18.5 7.3333"
      />
    </svg>
  )
}
